import { UseQueryResult, useQuery } from 'react-query'

import httpClient from 'services/http-client'

import { TEN_MINUTES_STALE_TIME } from 'constants/apis'

export const GET_PRODUCT_SEARCH_SETTINGS = '/products/searchSettings'

export type ProductSearchSettings = {
  newProductDurationInDays?: number
}

export const useProductSearchSettings = (): UseQueryResult<ProductSearchSettings> => {
  return useQuery({
    queryKey: [GET_PRODUCT_SEARCH_SETTINGS],
    queryFn: async () => {
      const { data: productSearchSettings } = await httpClient.get<ProductSearchSettings>(GET_PRODUCT_SEARCH_SETTINGS)
      return productSearchSettings
    },
    staleTime: TEN_MINUTES_STALE_TIME,
  })
}
